import Vue from 'vue'
import parsePushData from 'custom-push/pushParser/parsePushData'
import parseTopicInfo from 'custom-push/pushParser/parseTopicInfo'
import { isBetBuilderSelection } from '@ms/stores/betslip/func'

export const isSuspended = ({ eventStatus, marketStatus = 0 }) => {
  return marketStatus === 1 || eventStatus === 2
}
export const isUnavailable = ({ eventStatus, marketStatus = 0, isActive = 1 }) => {
  return isActive === 0 || marketStatus === 2 || marketStatus === 3 || (eventStatus !== 0 && eventStatus !== 1 && eventStatus !== 2 && eventStatus !== 7)
}

const getSpecifiers = (topicInfo = {}) => {
  let specifiers = topicInfo.marketSpecifiers || ''
  if (specifiers) {
    // topic中不能出现 |所以specifier多个的情况用&连接，现在在改回去
    specifiers = specifiers.split('&').join('|')
  }
  return specifiers
}

const isSameEvent = (selection, { eventId, marketId, specifiers }) => {
  if (selection.eventId === eventId && `${selection.marketInfo.id}` === `${marketId}`) {
    if (selection.marketInfo.specifiers && specifiers) {
      return selection.marketInfo.specifiers === specifiers
    }
    return true
  }
  return false
}

// 筛选目标比赛对象列表
const filterEvents = (selectionList = [], pushData = []) => {
  const topicInfo = parseTopicInfo(pushData[0], 'market')
  const { eventId, marketId } = topicInfo
  const specifiers = getSpecifiers(topicInfo)

  return selectionList.filter((x) => {
    if (isBetBuilderSelection(x)) {
      return x.eventId === eventId
    } else {
      return isSameEvent(x, { eventId, marketId, specifiers })
    }
  })
}

const updateOutcomeStatus = (event, eventStatus, marketStatus, isActive) => {
  const suspendedStatus = isSuspended({ eventStatus, marketStatus, isActive })
  const unavailableStatus = isUnavailable({ eventStatus, marketStatus, isActive })
  // console.log('unavailableStatus', unavailableStatus)
  Vue.set(event.outcomeInfo, 'isSuspended', suspendedStatus)
  Vue.set(event.outcomeInfo, 'isUnavailable', unavailableStatus)
}

/**
 * 根据推送消息，更新对应 event 信息
 * @param  {Object}  eventsMap    比赛列表经转换后的 map 对象
 * @param  {Array}  eventsOrder   比赛列表经转换后的 order 数组
 * @param  {Array}  pushData      推送消息对象
 * @param  {Boolean} isInsert     是否新增
 * @param  {Boolean} isDel        是否删除
 * @return {[type]}               [description]
 */
export const updateSelectionEvent = (selectionList, pushData) => {
  const eventInfo = parsePushData(pushData, 'event')
  const topicInfo = parseTopicInfo(pushData.topic, 'event')
  const { eventId } = topicInfo
  const events = selectionList.filter((x) => x.eventId === eventId)

  if (!events.length) return
  events.forEach((event) => {
    // pushTime直接合并上去，不受监控
    if ((event.pushTime && event.pushTime < eventInfo.pushTime) || !event.pushTime) {
      // 更新比赛信息
      const betStatus = eventInfo.betStatus
      delete eventInfo.betStatus

      if (isBetBuilderSelection(event)) {
        event.betBuilderSelections.forEach((x) => {
          Object.assign(x, eventInfo)
          updateOutcomeStatus(x, eventInfo.status, x.marketInfo.status, x.outcomeInfo.isActive)
          if (betStatus && (betStatus === 1 || betStatus === 2)) {
            Vue.set(x.marketInfo, 'status', betStatus)
          }
        })
      } else {
        Object.assign(event, eventInfo)
        updateOutcomeStatus(event, eventInfo.status, event.marketInfo.status, event.outcomeInfo.isActive)
        if (betStatus && (betStatus === 1 || betStatus === 2)) {
          Vue.set(event.marketInfo, 'status', betStatus)
        }
      }
    }
  })
}

/**
 * 根据推送消息，更新对应 event market 信息
 * @param  {Object} event    显示的 event 比赛对象，注意其中的 markets 信息有做 convert
 * @param  {Object} pushData 推送消息对象
 * @return {[type]}          [description]
 */
export const updateSelectionMarket = (selectionList, pushData) => {
  const pushMarketInfo = parsePushData(pushData, 'market')
  const events = filterEvents(selectionList, pushData)

  if (events.length) {
    const topicInfo = parseTopicInfo(pushData[0], 'market')
    const { eventId, marketId } = topicInfo
    const specifiers = getSpecifiers(topicInfo)

    events.forEach((event) => {
      if (isBetBuilderSelection(event)) {
        event.betBuilderSelections.forEach((x) => {
          if (isSameEvent(x, { eventId, marketId, specifiers })) {
            Object.assign(x.marketInfo, pushMarketInfo)
            updateOutcomeStatus(x, x.status, pushMarketInfo.status, x.outcomeInfo.isActive)
          }
        })
      } else {
        Object.assign(event.marketInfo, pushMarketInfo)
        updateOutcomeStatus(event, event.status, pushMarketInfo.status, event.outcomeInfo.isActive)
      }
    })
  }
}

/**
 * 根据推送消息，更新对应 event outcome 信息
 * @param  {Object} event    显示的 event 比赛对象，注意其中的 markets 信息有做 convert
 * @param  {Object} pushData 推送消息对象
 * @return {[type]}          [description]
 */
export const updateSelectionOutcome = (selectionList, pushData, callback = null) => {
  const pushOutcomeInfos = parsePushData(pushData, 'odds') || {}
  // 修正 odds 推送中的 market priority 位置
  const marketPushData = [...pushData]
  marketPushData[9] = marketPushData[10]
  const pushMarketInfo = parsePushData(marketPushData, 'market')

  // 更新 market
  updateSelectionMarket(selectionList, pushData)
  const events = filterEvents(selectionList, pushData)

  if (events.length && pushOutcomeInfos) {
    const topicInfo = parseTopicInfo(pushData[0], 'market')
    const { eventId, marketId } = topicInfo
    const specifiers = getSpecifiers(topicInfo)

    events.forEach((event) => {
      const originMarket = event.marketInfo
      const oldTime = originMarket ? +originMarket.pushTime || 0 : 0

      if (oldTime <= +pushMarketInfo.pushTime) {
        if (isBetBuilderSelection(event)) {
          let shouldUpdateOdds = false
          event.betBuilderSelections.forEach((x) => {
            if (isSameEvent(x, { eventId, marketId, specifiers })) {
              const { id } = x.outcomeInfo
              const outcome = pushOutcomeInfos[id]
              const oldOdds = x.outcomeInfo.odds
              const newOdds = outcome.odds
              if (oldOdds && newOdds && oldOdds !== newOdds) {
                shouldUpdateOdds = true
              }
              outcome.id = id
              Object.assign(x.outcomeInfo, outcome)
              updateOutcomeStatus(x, x.status, pushMarketInfo.status, outcome.isActive)
            }
          })
          if (shouldUpdateOdds) {
            callback && callback(event)
          }
        } else {
          const { id } = event.outcomeInfo
          const outcome = pushOutcomeInfos[id]
          outcome.id = id
          Object.assign(event.outcomeInfo, outcome)
          updateOutcomeStatus(event, event.status, pushMarketInfo.status, outcome.isActive)
        }
      }
    })
  }
}
